import { useRef, useState } from 'react';
import { Crop } from 'react-image-crop';
import { useDebouncedCallback } from 'use-debounce';

import { centerAspectCrop } from './lib';

interface UseCropImageParams {
  ratio: number;
}

export const useCropImage = (params: UseCropImageParams) => {
  const { ratio } = params;

  const [crop, setCrop] = useState<Crop>(
    centerAspectCrop({ imageWidth: 100, imageHeight: 100, ratio }),
  );
  const [completeCrop, setCompleteCrop] = useState<Crop>();

  const onCropComplete = useDebouncedCallback((_completeCrop: Crop) => {
    setCompleteCrop(_completeCrop);
  }, 100);

  const imgRef = useRef<HTMLImageElement>(null);

  const onCropChange = (pixel: Crop) => {
    setCrop(pixel);
  };

  return {
    crop,
    onCropChange,
    completeCrop,
    onCropComplete,
    imgRef,
  };
};
